/*Copyright (c) 2023. Honeywell International, Inc. All rights reserved.
This file contains trade secrets of Honeywell International, Inc. 
No part may be reproduced or transmitted in any form by any means or for anypurpose without the express written permission of Honeywell. */
import { IErrorProps } from "../../models";

/**
 *
 * Updates error list ..Pass it the current error, existing Errors for that functionality
 */

export const updateErrorList = (
  err: any,
  currentErrors: Array<IErrorProps>
) => {
  let newError: IErrorProps = {
    errorCode: err.status,
    errorMessage: err.data,
  };

  // Error comes in 2 formats one where err.data has message ,  here we need data
  // other where err.data is of Object type. Here we need err.data.title
  if (typeof err.data === "string") {
    newError.errorMessage = err.data;
  } else if (typeof err?.data?.title === "string") {
    newError.errorMessage = err.data.title;
  } else {
    newError.errorMessage = err.statusText;
  }

  let updatedErrorList = [...currentErrors, newError];
  if (currentErrors.some((x) => x.errorMessage === newError.errorMessage)) {
  } else {
    currentErrors = updatedErrorList;
  }
  return currentErrors;
};
export default updateErrorList;
